import { AnnotatedMarkup } from '@/components/AnnotatedMarkup'
import { StoryLineParagraphModelType, annotationType } from '@/types/cms/Storylines'
import styles from './StorylineParagraph.module.scss'

export default function StorylineParagraph({
  item,
}: Readonly<{
  item: { model: StoryLineParagraphModelType } | any
}>) {
  const model = item?.model

  let p: annotationType

  if (!model) {
    return null
  }

  if (!model.fields?.paragraph) {
    p = {
      value: model.fields?.value ?? '',
      annotations: Array.isArray(model.fields?.annotations)
        ? model.fields.annotations.map((annotation: any) => (annotation.value ? { ...annotation.value } : annotation))
        : [],
    }
  } else {
    p = model.fields.paragraph
  }

  return <AnnotatedMarkup referenced={model?.referenced} fields={p} className={styles.p} />
}
